module.exports = __webpack_public_path__ + "static/fisc-logo-e20777d6137c8bf5f0ac71970c3c10ac.png";